import moment from 'moment';

export default class AdminViewStudentModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.id = data.id || data.user_id || 0;
    this.email = data.email || '';
    this.first_name = data.first_name || '';
    this.last_name = data.last_name || '';
    this.school_name = data.school_name || '';
    this.date_joined = data.date_joined ? moment(data.date_joined).toDate() : null;
    this.last_login = data.last_login ? moment(data.last_login).toDate() : null;
    this._is_active = data._is_active || false;
    this.city_name = data.city_name || '';
    this.state_name = data.state_name || '';
  }

  get status() {
    if (this._is_active) {
      return 'Active';
    }
    return 'Inactive';
  }

  get name() {
    return `${this.first_name} ${this.last_name}`;
  }
}
